import {Poker2Constants} from "../../../constants/Poker2Constants";
import {SFConstants} from "../../../constants/SFConstants";
import {Constants} from "../../../constants/shared/Constants";
import {Poker2Model} from "../../../model/Poker2Model";
import {Poker2Command} from "../Poker2Command";

/** SPEZIAL EVENT */
export class SEECommand extends Poker2Command {
    protected get cmdId(): string {
        return "see";
    }
    /**
     *
     * @param error
     * @param params Array. First element contains the error code. Second Element contains a String with the active event ids.
     * E.g. 'params[1] = "1#2";' -> means there are two events active with the ids "1" and "2"
     * @return Returns false for error code not equal 0, true for error code 0
     */
    public executeCommand(error: number, params: any[]): boolean {
        if (error == 0) {
            var dict: Map<any, any> = new Map<any, any>();
            var currentEvents: Number[] = String(params[1]).split('#').map((eventId) => { return parseInt(eventId); });
            var atLeastOneValidEventActive: boolean = false;

            dict.set(1, "halloween");
            dict.set(2, "xmas");
            dict.set(3, "football");

            var eventId: string;
            for (var i: number = 0; i < currentEvents.length; i++) {
                eventId = dict.get(currentEvents[i]);

                if (eventId) {
                    Poker2Model.sessionData.currentEvents.push(eventId);
                }

                // check if event is available
                if (dict.get(currentEvents[i])) {
                    atLeastOneValidEventActive = true;
                }
            }

            // store information wether at least one event is active or not
            Poker2Model.eventIsActive = atLeastOneValidEventActive;

            // EVENT-TEST: CafeModel.userData.currentEvents.push( 1, 2, 3 );
            /*if (params.length>0)
            {
                var expiringEvents:Array = String(params.shift()).split('#');
                while (expiringEvents.length > 0 && expiringEvents[0]!= "")
                    layoutManager.showDialog( FashionTimeFeatureDialog.NAME, new FashionTimeFeatureDialogProperties( expiringEvents.shift() ));
            }*/
            return true;
        }
        return false;

    }

    /**
    * TRANSPILER GENERATED FUNCTION: If a overriding getter is defined, the setter must be defined as well. WARNING: the defining class was not found, so the parentclass was assumed. Please check if this call is correct.
    **/
    protected set cmdId(value/*:String*/)/*:void*/ {
        Object.getOwnPropertyDescriptor(Poker2Command.prototype, "cmdId").set.call(this, value);
    }
}
